// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newDash-leyendaSobre {
	height: 25px;
	width: 25px;
	background-color: #0ab4c4;
	border-radius: 6px;
	margin-right: 10px;
	font-size: 12px;
}
.newDash-leyendaIgual {
	height: 25px;
	width: 25px;
	background-color: #5f52c4;
	border-radius: 6px;
	margin-right: 10px;
	font-size: 12px;
}
.newDash-leyendaBajo {
	height: 25px;
	width: 25px;
	background-color: #ec6376;
	border-radius: 6px;
	margin-right: 10px;
	font-size: 12px;
}

.newDash-subtitles {
	text-align: center;
	font-size: 22px;
	color: gray;
	font-weight: bold;
	margin-bottom: 40px;
}

.newDash-title {
	text-align: center;
	font-size: 30px;
	color: gray;
	font-weight: bold;
	margin-bottom: 40px;
}

.newDash-piramide {
	border-bottom: 250px solid #5f52c4;
	border-left: 125px solid transparent;
	height: 0;
	width: 0px;
	margin-right: auto;
	margin-left: auto;
	position: absolute;
	bottom: 220px;
}

.newDash-textPyramid {
	text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
	font-weight: bold;
	color: #000;
}

.newDashboard-label {
	width: 120px;
	height: 60px;
	border-radius: 10% / 50%;
	padding: 20px;
	color: #fff;
	background-color: #00555d;
	font-weight: bold;
	text-align: center;
}

.newDashboard-text {
	font-weight: bold;
	font-size: 30px;
}

.goToSalaries {
	cursor: pointer;
}

.goToSalaries:hover {
	transform: scale(1.05);
}
`, "",{"version":3,"sources":["webpack://./src/Views/Services/Components/PayBalance/Views/NewDashboard.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kCAAkC;CAClC,oCAAoC;CACpC,SAAS;CACT,UAAU;CACV,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,+EAA+E;CAC/E,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,wBAAwB;CACxB,aAAa;CACb,WAAW;CACX,yBAAyB;CACzB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,sBAAsB;AACvB","sourcesContent":[".newDash-leyendaSobre {\r\n\theight: 25px;\r\n\twidth: 25px;\r\n\tbackground-color: #0ab4c4;\r\n\tborder-radius: 6px;\r\n\tmargin-right: 10px;\r\n\tfont-size: 12px;\r\n}\r\n.newDash-leyendaIgual {\r\n\theight: 25px;\r\n\twidth: 25px;\r\n\tbackground-color: #5f52c4;\r\n\tborder-radius: 6px;\r\n\tmargin-right: 10px;\r\n\tfont-size: 12px;\r\n}\r\n.newDash-leyendaBajo {\r\n\theight: 25px;\r\n\twidth: 25px;\r\n\tbackground-color: #ec6376;\r\n\tborder-radius: 6px;\r\n\tmargin-right: 10px;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.newDash-subtitles {\r\n\ttext-align: center;\r\n\tfont-size: 22px;\r\n\tcolor: gray;\r\n\tfont-weight: bold;\r\n\tmargin-bottom: 40px;\r\n}\r\n\r\n.newDash-title {\r\n\ttext-align: center;\r\n\tfont-size: 30px;\r\n\tcolor: gray;\r\n\tfont-weight: bold;\r\n\tmargin-bottom: 40px;\r\n}\r\n\r\n.newDash-piramide {\r\n\tborder-bottom: 250px solid #5f52c4;\r\n\tborder-left: 125px solid transparent;\r\n\theight: 0;\r\n\twidth: 0px;\r\n\tmargin-right: auto;\r\n\tmargin-left: auto;\r\n\tposition: absolute;\r\n\tbottom: 220px;\r\n}\r\n\r\n.newDash-textPyramid {\r\n\ttext-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;\r\n\tfont-weight: bold;\r\n\tcolor: #000;\r\n}\r\n\r\n.newDashboard-label {\r\n\twidth: 120px;\r\n\theight: 60px;\r\n\tborder-radius: 10% / 50%;\r\n\tpadding: 20px;\r\n\tcolor: #fff;\r\n\tbackground-color: #00555d;\r\n\tfont-weight: bold;\r\n\ttext-align: center;\r\n}\r\n\r\n.newDashboard-text {\r\n\tfont-weight: bold;\r\n\tfont-size: 30px;\r\n}\r\n\r\n.goToSalaries {\r\n\tcursor: pointer;\r\n}\r\n\r\n.goToSalaries:hover {\r\n\ttransform: scale(1.05);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
